module.exports = __webpack_public_path__ + "media/images/flags/fi-eb793b740dd4fa0f8b6301a4b74a435e.svg";